import React from 'react';
import { useSelector } from "react-redux";
import * as actionCreator from "../../../../action/index.js";
import CurrencyFormat from 'react-currency-format';

const Total = () => {

  const state = useSelector((state) => ({
    ...state.reducer,
    ...state.orderExtrasReducer,
    ...state.priceUpdateReducer,
  }));

  let newCalculation = 0;
  if (state.const_var.post_data.building !== undefined) {
    if (
      state.order_extra_items['dont_show_processing_fee_pdf'] === "1" &&
      parseInt(state.const_var.order_extra_items['processing_fee']) !== 0
    ) {
      newCalculation =
        parseInt(state.const_var.post_data.building.down_payment_total -
          state.const_var.post_data.building.down_payment_discount_total) +
        parseInt(state.const_var.order_extra_items['processing_fee']);
    } else {
      newCalculation = (
        parseInt(state.const_var.post_data.building.down_payment_total -
          state.const_var.post_data.building.down_payment_discount_total)
      ).toFixed(2);
    }
  }
  

  
  let manufacturer_discount =
    state.const_var.post_data.building !== undefined &&
    state.const_var.post_data.building.discount_amount !== undefined &&
    state.const_var.post_data.building.discount_amount !== 0;

  let surFlag = 0;
  if (
    state.const_var.post_data.building !== undefined &&
    state.const_var.post_data.building.surcharge_on_discounted_subtotal === 1
  ) {
    let surVal =
      state.const_var.post_data.building !== undefined &&
      state.const_var.post_data.building.surcharge_amount !== undefined
        ? state.const_var.post_data.building.surcharge_amount
        : 0;
    surFlag = manufacturer_discount
      ? (
          parseFloat(state.const_var.post_data.building.order_total) +
          parseFloat(state.const_var.BuildingPriceArrar["custom_subTotal"]) +
          parseFloat(surVal)
        ).toFixed(2)
      : state.const_var.BuildingPriceArrar['sub_order_total'] !== undefined
      ? (
          parseFloat(state.const_var.BuildingPriceArrar['sub_order_total']) +
          parseFloat(state.const_var.BuildingPriceArrar["custom_subTotal"])
        ).toFixed(2)
      : 0;
  } else {
    surFlag =
      state.const_var.post_data.building !== undefined
        ? (
            state.const_var.post_data.building.order_total +
            state.const_var.BuildingPriceArrar["custom_subTotal"]
          ).toFixed(2)
        : 0;
  }

  return (
    <>
      <CurrencyFormat
        value={surFlag}
        displayType={'text'}
        thousandSeparator={true}
        prefix={'$'}
      />
    </>
  );
};

export default Total;